import { render, staticRenderFns } from "./zpList.vue?vue&type=template&id=dd7cff2c&scoped=true&"
import script from "./zpList.vue?vue&type=script&lang=js&"
export * from "./zpList.vue?vue&type=script&lang=js&"
import style0 from "./zpList.vue?vue&type=style&index=0&id=dd7cff2c&scoped=true&lang=css&"
import style1 from "./zpList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7cff2c",
  null
  
)

export default component.exports